import routes from 'js/core_pre_webpack/routes';

export const CHECKOUT_TRIGGER = 'loswp-tabs-hero';

export const packCheckoutOpts = (workId: number) => ({
  feature: 'BULK_DOWNLOAD',
  trigger: CHECKOUT_TRIGGER,
  upgradeRedirect: encodeURIComponent(
    routes.show_work_url({ id: workId, bulkDownload: true }),
  ),
});
